// Component: FullImage. Props: standard image info.
//
// This renders a full-size display of a single image, on top of a scrolling
// list, using the image info passed in.
import { useCallback, useEffect } from "react";

function FullImage(props) {
  const {onClose, imageInfo} = props;
  const {fullUrl} = imageInfo;

  // Handle the Escape key for closing the window. In the future, will want to
  // handle arrow keys as well, so a generic key handler make sense
  const keyHandler = useCallback((event) => {
    if (event.key === 'Escape') {
      onClose();
      event.stopPropagation();
    }
  }, [onClose]);

  useEffect(() => {
    document.addEventListener("keydown", keyHandler, false);

    return () => {
      document.removeEventListener("keydown", keyHandler, false);
    };
  }, [keyHandler]);

  const wrapperStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1,
    backgroundColor: '#003',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden'
  };

  const imageStyle = {
    flex: '1 1 auto',
    objectFit: 'contain',
    width: '100%',
    height: '100%'
  };

  const commentDiv = {
    fontSize: '90%',
    position: 'fixed',
    bottom: 0,
    width: '100%',
    textAlign: 'center',
    padding: '0.5em',
    backgroundColor: 'rgba(0, 0, 48, 0.5)',
    color: '#def',
    zIndex: 2,
    lineHeight: '130%',
  }

  const copyrightStyle = {
    fontSize: '80%',
    lineHeight: '130%',
  };

  const personsStyle = {
    fontSize: '80%',
    color: '#cfc',
    lineHeight: '130%',
  };

  const title = imageInfo.title;
  let description = '';
  if (imageInfo.description) {
    description = imageInfo.description;
  }
  if (imageInfo.dateTime) {
    if (description) {
      description += ': ';
    }
    description += imageInfo.dateTime;
  }

  let copyright = imageInfo.copyright;
  if (!copyright && imageInfo.year && imageInfo.year < 2100) {
    copyright = 'Copyright ©' + imageInfo.year + ' by Eric Grivel';
    if (imageInfo.year > 1989) {
      copyright += ' and Nicoline Smits';
    }
  }

  let persons = imageInfo.persons;

  return (
    <>
      <div
        onClick={() => onClose()}
        style={wrapperStyle}
      >
        <img
          alt='something here'
          src={fullUrl}
          style={imageStyle}
        />
      </div>
      <div style={commentDiv}>
        {
          title &&
          <div><b>{title}</b></div>
        }
        {
          description &&
          <div>{description}</div>
        }
        {
          persons &&
          <div style={personsStyle}>In this photo: {persons}</div>
        }
        {
          copyright &&
          <div style={copyrightStyle}>{copyright}</div>
        }
      </div>
    </>
  );
}

export default FullImage;
